import { useFinanceApi } from 'infrastructure/api';
import { useCrudService } from 'framework/crud';

export const PAYROLL_DISTRIBUTION_PATH = '/payroll-distribution';
export const READ_PAYROLL_DISTRIBUTION = 'EMPLOYEE_READ_FINANCE_UNSENSITIVE_METRICS';
export const PERFORM_EXPENSE_DISTRIBUTION = 'COMPANY_PERFORM_EXPENSE_DISTRIBUTION';
const PAYROLL_DISTRIBUTION_URL = '/accounting-cycle/distribute-expenses';

const PAYROLL_DISTRIBUTION_STATUSES = {
  COMPLETED: 'COMPLETED',
  SKIPPED: 'SKIPPED',
};

export const PAYROLL_DISTRIBUTION_STATUSES_OPTIONS = {
  [PAYROLL_DISTRIBUTION_STATUSES.COMPLETED]: 'Completed',
  [PAYROLL_DISTRIBUTION_STATUSES.SKIPPED]: 'Skipped',
};

const usePayrollDistributionService = () => {
  const { sendPostRequest } = useFinanceApi();
  const baseCrud = useCrudService({
    useService: useFinanceApi,
    listResourceUrl: PAYROLL_DISTRIBUTION_URL,
    singleResourceUrl: `${PAYROLL_DISTRIBUTION_URL}/:id`,
  });

  const performExpenseDistribution = async (period: string) => {
    const result = await sendPostRequest('/accounting-cycle/distribute-expenses', { period });
    return result.json();
  };

  const performSandboxExpenseDistribution = async (period: string) => {
    const result = await sendPostRequest('/accounting-cycle/distribute-expenses-sandbox', { period });
    return result.json();
  };

  return {
    ...baseCrud,
    performExpenseDistribution,
    performSandboxExpenseDistribution,
  };
};

export default usePayrollDistributionService;
